import style from './styles.module.css'
const Skelton = ({ width, height }) => {
  return (<>
            <div className={style.skelton} style={{ width, height }}>

            </div>
        </>)
}

export default Skelton
